// extracted by mini-css-extract-plugin
module.exports = {"sellerExternalLink":"SellerExternalWebsite_sellerExternalLink__p77pz"};